<app-load-general [load]="isLoading"></app-load-general>
<div class="h-screen w-full flex justify-center items-center">
  <div class="box-home">
    <form
      [formGroup]="loginForm"
      (ngSubmit)="login()"
      class="flex flex-col justify-between gap-7 p-6 aa-input-general"
    >
      <div class="w-full flex justify-center items-center">
        <img alt="einteligent" class="w-112.5" src="assets/icons/logo-dynamic-einteligent.svg" />
      </div>
      <div class="w-65 m-auto">
        <app-input-general
          [label]="'Usuario'"
          [placeholder]="'Usuario'"
          [type]="'text'"
          [formControlGeneral]="getControl(loginForm, 'username')"
        ></app-input-general>
      </div>
      <div class="w-65 m-auto">
        <app-input-general
          [label]="'Contraseña'"
          [placeholder]="'Contraseña'"
          [type]="'password'"
          [formControlGeneral]="getControl(loginForm, 'password')"
        ></app-input-general>
      </div>
      <div class="w-66.25 m-auto justify-center flex">
        <button
          class="button-general w-full"
          matButton
          type="submit"
          [disabled]="isLoading || loginForm.invalid"
        >
          <div class="flex justify-center items-center gap-4">
            <img alt="Entrar" src="assets/icons/icon_entrar.svg" class="h-7" />
            <div>Entrar</div>
          </div>
        </button>
      </div>
      <div class="w-66.25 m-auto justify-center flex">
        <button
          class="button-general w-full"
          matButton
          type="button"
          (click)="openRecoverPasswordDialog()"
        >
          <div class="flex justify-center items-center gap-4">
            <img
              alt="Recuperar Contraseña"
              src="assets/icons/icon_recuperar_contraseña.svg"
              style="height: 28px"
            />
            <div>Recuperar Contraseña</div>
          </div>
        </button>
      </div>
    </form>
  </div>
</div>
